//Featured product hotspots modal popup functionality
import $ from 'jquery';

export function hotspots() {
  const $featuredProduct = $('.featured-product');

  if ($featuredProduct.length > 0) {
    $.each($featuredProduct, function () {
      const $section = $(this);
      const $hotspots = $section.find('.hotspots__hotspot');
      const $allModals = $('.hotspots__hotspot__modal');

      $.each($hotspots, function () {
        const $hotspot = $(this);
        const $svg = $hotspot.find('svg.hotspot-icon');
        const $modal = $hotspot.find('.hotspots__hotspot__modal');
        const $closeIcon = $modal.find('.modal__close-icon');

        $closeIcon.on('click', function () {
          $($modal)
            .parent('.hotspots__hotspot')
            .toggleClass('active')
            .attr('aria-selected', 'false')
            .attr('tabindex', -1);

          $($modal).prop({ hidden: true });
        });

        $svg.on('click', function () {
          $hotspots.removeClass('active');

          $(this)
            .parent('.hotspots__hotspot')
            .toggleClass('active')
            .attr('aria-selected', 'true')
            .attr('tabindex', 0);

          $($allModals).prop({ hidden: true });
          $($modal).prop({ hidden: false });
        });
      });
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    const tabList = document.querySelectorAll('.featured-product');

    // Enable arrow navigation between tabs in the tab list

    tabList.forEach((list) => {
      const tabs = list.querySelectorAll('[role="tab"]');
      let tabFocus = 0;
      list.addEventListener('keydown', (e) => {
        // Move right
        if (e.code === 'ArrowRight' || e.code === 'ArrowLeft') {
          tabs[tabFocus].setAttribute('tabindex', -1);
          tabs[tabFocus].querySelector('div').setAttribute('hidden', '');
          tabs[tabFocus].classList.toggle('active');
          if (e.code === 'ArrowRight') {
            tabFocus++;
            // If we're at the end, go to the start
            if (tabFocus >= tabs.length) {
              tabFocus = 0;
            }
            // Move left
          } else if (e.code === 'ArrowLeft') {
            tabFocus--;
            // If we're at the start, move to the end
            if (tabFocus < 0) {
              tabFocus = tabs.length - 1;
            }
          }

          tabs[tabFocus].setAttribute('tabindex', 0);
          tabs[tabFocus].querySelector('div').removeAttribute('hidden');
          tabs[tabFocus].classList.toggle('active');
          tabs[tabFocus].focus();
        }
      });
    });
  });
}
